/**
 * @author https://github.com/react-hookz/web/blob/c545ce7c9125c920cb5d48ad982dee4d11a006b6/src/useDebouncedState/index.ts
 */
import { useDebouncedCallback } from './useDebouncedCallback.js';
import { useState } from 'react';
/**
 * Like `useState` but its state setter is debounced.
 * @param initialState Initial state to pass to underlying `useState`.
 * @param delay Debounce delay.
 * @param maxWait Maximum amount of milliseconds that function can be delayed
 * before it's force execution. 0 means no max wait.
 */
export const useDebouncedState = (initialState, delay, maxWait = 0) => {
    const [state, setState] = useState(initialState);
    return [state, useDebouncedCallback(setState, [], delay, maxWait)];
};
//# sourceMappingURL=useDebouncedState.js.map